import React from "react"
import styled from "styled-components"
import { theme } from "Theme"
import Link from "../components/Link"

const StyledLink = styled((props) => <Link {...props} />)`
  display: inline-block;
  text-decoration: none;
  text-decoration-skip-ink: auto;
  position: relative;
  transition: ${theme.transition};
  cursor: pointer;
  color: ${theme.colors.primary};
  &:hover,
  &:focus,
  &:active {
    color: ${theme.colors.primary};
    outline: 0;
    &:after {
      width: 100%;
    }
  }
  &:after {
    content: "";
    display: block;
    width: 0;
    height: 1px;
    position: relative;
    bottom: 0.37em;
    background-color: ${theme.colors.primary};
    transition: ${theme.transition};
  }
`

const InlineLink = ({ children, to, target, track, title, ...other }) => (
  <StyledLink to={to} track={track} title={title} target={target} {...other}>
    {children}
  </StyledLink>
)

export default InlineLink
